export function withOverrideProps<P> (Component: React.ComponentType<P>, overrideProps: Partial<P>) {
    return (props: P) => <Component {...props} {...overrideProps} />
  }